import { fetchApi } from "infrastructure/api";
import type { Entity } from "types";
import { HttpVerb } from "consts/api";
import { ApiRoutes } from "consts/enpoints/api";
import type {
    Merchant,
    OnboardingRequestParams,
    WithCompletion,
    WithUser
} from "features/ecommerce/types";

export const getOnboardingsBusinessInformationSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsBusinessInformationSteps(userId));

export const putOnboardingsBusinessInformationSteps = (body: OnboardingRequestParams & Partial<Merchant.OnboardingBusinessInformation>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsBusinessInformationSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsBillingFinanceSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsBillingFinanceSteps(userId));

export const putOnboardingsBillingFinanceSteps = (body: OnboardingRequestParams & Partial<Merchant.OnboardingBankingAndFinance>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsBillingFinanceSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsMediaComplianceSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsMediaComplianceSteps(userId));

export const putOnboardingsMediaComplianceSteps = (body: OnboardingRequestParams & Partial<Merchant.OnboardingMediaAndComplianceCheck>) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsMediaComplianceSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

export const getOnboardingsIdentityVerificationSteps = ({ userId }: OnboardingRequestParams) =>
    fetchApi(ApiRoutes.GetOnboardingsIdentityVerificationSteps(userId));

export const putOnboardingsIdentityVerificationSteps = (body: OnboardingRequestParams & WithCompletion) => {
    const { userId } = body;

    return fetchApi(ApiRoutes.PutOnboardingsIdentityVerificationSteps(userId), {
        method: HttpVerb.Put,
        body
    });
};

// export const putOnboardingsUboIdentities = (body: OnboardingRequestParams & Partial<UboIdentity>) => {
//     const { userId } = body;

//     return fetchApi(ApiRoutes.PutOnboardingsUboIdentities(userId), {
//         method: HttpVerb.Put,
//         body
//     });
// };

export const deleteOnboardingsUboIdentities = ({ userId, pki }: WithUser & Entity) =>
    fetchApi(ApiRoutes.DeleteOnboardingsUboIdentities(userId, pki), {
        method: HttpVerb.Delete
    });
